import { createFileRoute } from "@tanstack/react-router"
import Login from "@/pages/account/login"

type LoginSearch = {
  email?: string
  redirect?: string
}

export const Route = createFileRoute("/$countryCode/account/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    email: typeof search.email === "string" ? search.email : undefined,
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Sign in | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Login,
})
